import React, { PropsWithChildren } from "react";
import { Button, Tabs } from "antd";

import styles from "./matter-editor-content.module.css";
import { useRestApi } from "~/hooks";
import { MatterTemplateDownloadButton } from "./matter-template-download-button";
const { ["tabs__tab-bar"]: tabBarClassName } = styles as any;

export type MatterEditorContentProps = PropsWithChildren<{
  matterId: number;
  activeTab: string;
  onChangeTab: (newActiveTab: string) => void;
  matterTitle: string;
  template: boolean;
}>;

export const MatterEditorContent: React.FC<MatterEditorContentProps> = ({
  activeTab,
  onChangeTab,
  children,
  matterTitle,
  template,
  matterId,
}) => {
  const renderTabBar = (props: any, DefaultTabBar: any) => (
    <DefaultTabBar {...props} className={tabBarClassName} />
  );
  return (
    <Tabs
      tabBarExtraContent={
        template ? (
          <div style={{ display: "flex", alignItems: "center", marginRight: 15, gap: 15 }}>
            <h2 style={{ marginBottom: 0, padding: 0, display: "inline" }}>{matterTitle}</h2>
            <MatterTemplateDownloadButton templateId={matterId} />
          </div>
        ) : null
      }
      onChange={onChangeTab}
      activeKey={activeTab}
      type="card"
      renderTabBar={renderTabBar}
    >
      {children}
    </Tabs>
  );
};
